/**
 * Menjelaskan KENAPA pendaftaran gagal — duplikasi sengaja dari `apps/web/src/lib/galat-signup.ts`
 * (CRM), bukan diimpor lintas-app (dua app terpisah, fungsi murni sekecil ini tidak sepadan
 * dipaketkan bersama — pola sama `demo-cooldown.ts` sebelumnya). Dipakai `TrialStartPage.tsx`
 * (BLD-015 lanjutan, 2 Okt 2026, trial 14 hari Workforce tersendiri).
 *
 * Sebelumnya semua kegagalan `signUp` berujung pada satu kalimat — "Gagal mendaftar. Coba email
 * lain." — yang salah arah untuk kasus cooldown kirim-ulang email (429
 * `over_email_send_rate_limit`, ~60 detik per alamat setelah email konfirmasi diminta): bukan
 * soal email yang dipakai, dan menyuruh ganti email tidak membantu sama sekali.
 */

export type SebabGagalSignup = 'tunggu-email-sebelumnya' | 'lain';

export const PESAN_SIGNUP_DEFAULT = 'Gagal mendaftar. Coba email lain.';

export function sebabGagalSignup(error: unknown): SebabGagalSignup {
  const e = error as { code?: unknown; status?: unknown; message?: unknown } | null;
  if (!e || typeof e !== 'object') return 'lain';

  const kode = typeof e.code === 'string' ? e.code : '';
  const status = typeof e.status === 'number' ? e.status : undefined;
  const pesan = typeof e.message === 'string' ? e.message : '';

  if (
    kode === 'over_email_send_rate_limit' ||
    status === 429 ||
    /you can only request this after \d+ seconds?/i.test(pesan)
  ) {
    return 'tunggu-email-sebelumnya';
  }
  return 'lain';
}

export function pesanGagalSignup(sebab: SebabGagalSignup): string {
  switch (sebab) {
    case 'tunggu-email-sebelumnya':
      return (
        'Email konfirmasi baru saja dikirim. Tunggu sekitar 1 menit sebelum mencoba lagi — ' +
        'cek juga folder spam kalau belum terlihat.'
      );
    default:
      return PESAN_SIGNUP_DEFAULT;
  }
}
